/**
 * FokusFilterSection - Collapsible filter section in dropdown
 */

import React from 'react';
import { ChevronIcon } from '../../filterUtils';

const FokusFilterSection = ({ 
  title, 
  sectionId, 
  expandedSections, 
  toggleSection, 
  count, 
  children 
}) => (
  <div className="fokus-button__section">
    <button 
      className="fokus-button__section-header" 
      onClick={() => toggleSection(sectionId)}
    >
      <span className="fokus-button__section-title">{title}</span>
      {count > 0 && <span className="fokus-button__section-count">{count}</span>}
      <span className={`fokus-button__section-chevron ${expandedSections.has(sectionId) ? 'fokus-button__section-chevron--open' : ''}`}>
        <ChevronIcon />
      </span>
    </button>
    {expandedSections.has(sectionId) && (
      <div className="fokus-button__section-options">{children}</div>
    )}
  </div>
);

export default FokusFilterSection;
